/* @flow */
import * as React from 'react';

import type { DecoratedProduct } from '@gandi/cart';

import { useTranslator } from '@gandi/translate';
import {
  ListRow,
  ListCell,
  ListCellGroup,
  ListItem,
} from '@gandi/ui/deprecated';

import CellRowGroup from 'src/components/shared/CellRowGroup';

import Price from './components/Rows/Price';

import styles from './PaasCreateDetails.scss';

type Props = {
  product: DecoratedProduct,
};

export function PassCreateDetails({
  product,
}: Props): null | React.MixedElement {
  const { __ } = useTranslator();

  if (
    !product.payload.data_disk_additional_size ||
    product.payload.data_disk_additional_size <= 0
  ) {
    return null;
  }

  // convert prices array to an indexed map:
  const prices = {
    instance: 0,
    disk: 0,
  };

  // { description: string, base_price: number }
  product.prices.forEach(price => {
    switch (price.description) {
      case 'disk':
        prices.disk = price.base_price;
        break;
      case `${product.payload.product_name || ''}_${
        product.payload.size || ''
      }`:
        if (!price.is_discount) {
          prices.instance = price.base_price;
        }
        break;
      default:
      // do nothing
    }
  });
  const unit = __('GB');

  return (
    <div>
      <ListRow separatorBottom>
        <ListItem className={styles.subproductItem}>
          <CellRowGroup>
            <ListCellGroup>
              <ListCell>{__('Instance')}</ListCell>
            </ListCellGroup>
          </CellRowGroup>
          <ListCell className={styles.allowMultiLine}>
            <Price
              price={prices.instance}
              showExcludeVatMention={product.hasTaxes}
            />
          </ListCell>
        </ListItem>
      </ListRow>
      <ListRow separatorBottom>
        <ListItem className={styles.subproductItem}>
          <CellRowGroup>
            <ListCellGroup>
              <ListCell>{__('Extra disk space')}</ListCell>
              <ListCell type="secondary">
                {__('%(value)d %(unit)s', {
                  // XXX: improve or fix Product type
                  value: product.payload.data_disk_additional_size || 0,
                  unit: unit || '',
                })}
              </ListCell>
            </ListCellGroup>
          </CellRowGroup>
          <ListCell className={styles.allowMultiLine}>
            <Price
              price={prices.disk}
              showExcludeVatMention={product.hasTaxes}
            />
          </ListCell>
        </ListItem>
      </ListRow>
    </div>
  );
}
